import { mode, GlobalStyleProps } from '@chakra-ui/theme-tools';

import * as externals from './externals';

const externalsStyles = () =>
  Object.values(externals).reduce(
    (acc, cur) => ({
      ...acc,
      ...(typeof cur === 'function' ? cur() : cur),
    }),
    {},
  );

export const styles = {
  global: (props: GlobalStyleProps) => ({
    html: {
      bg: mode('whiteAlpha.600', 'whiteAlpha.600')(props),
      fontSize: {
        base: 'xs',
        lg: 'xs',
        xl: 'sm',
        '2xl': 'md',
      },
      minH: '100vh',
    },
    body: {
      bg: mode('whiteAlpha.600', 'gray.800')(props),
      color: mode('gray.800', 'gray.800')(props),
      h: '100%',
      WebkitTapHighlightColor: 'transparent',
    },
    '#chakra-toast-portal > *': {
      pt: 'safe-top',
      pl: 'safe-left',
      pr: 'safe-right',
      pb: 'safe-bottom',
    },
    '.droppable-column ::-webkit-scrollbar': {
      height: '12px',
      width: '12px',
    },
    '.droppable-column ::-webkit-scrollbar-track': {
      height: '4px',
      borderLeft: '2px solid #5BA699',
      borderRight: '2px solid #5BA699',
      borderTop: '2px solid #5BA699',
      borderBottom: '2px solid #5BA699',
      background: 'primary.600',
      borderRadius: '24px',
    },
    '.droppable-column ::-webkit-scrollbar-thumb': {
      background: 'primary.700',
      borderRadius: '24px',
    },
    ...externalsStyles(),
  }),
};
